import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Dashboard from "./components/screens/Dashboard";
import AlertsDashboard from "./components/screens/AlertsDashboard";
import AnalyticsDashboard from "./components/screens/AnalyticsDashboard";
import ConservationDashboard from "./components/screens/ConservationDashboard";
import WelcomeScreen from "./components/screens/WelcomeScreen";
import LeakDetectionDashboard from "./components/screens/LeakDetectionDashboard";
import WaterUsageTracker from "./components/screens/WaterUsageTracker";
import WaterConservationTips from "./components/screens/WaterConservationTips";
import UsageDashboard from "./components/screens/UsageDashboard";
import TopUpDashboard from "./components/screens/TopUpDashboard";
import SettingsScreen, { MeasurementUnitsScreen, LanguageScreen, PasswordSecurityScreen } from "./components/screens/SettingsScreen";
import MakePaymentScreen from "./components/screens/MakePaymentScreen";
import ProfileScreen from "./components/screens/ProfileScreen";
import ChangePlanScreen from "./components/screens/ChangePlanScreen";
import WaterRestrictionsScreen from "./components/screens/WaterRestrictionsScreen";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/alerts" element={<AlertsDashboard />} />
        <Route path="/analytics" element={<AnalyticsDashboard />} />
        <Route path="/conservation" element={<ConservationDashboard />} />
        <Route path="/leak-detection" element={<LeakDetectionDashboard />} />
        <Route path="/usage-tracker" element={<WaterUsageTracker />} />
        <Route path="/conservation-tips" element={<WaterConservationTips />} />
        <Route path="/usage" element={<UsageDashboard />} />
        <Route path="/top-up" element={<TopUpDashboard />} />
        <Route path="/topup" element={<TopUpDashboard />} />
        <Route path="/settings" element={<SettingsScreen />} />
        <Route path="/measurement-units" element={<MeasurementUnitsScreen />} />
        <Route path="/language" element={<LanguageScreen />} />
        <Route path="/password-security" element={<PasswordSecurityScreen />} />
        <Route path="/restrictions" element={<WaterRestrictionsScreen />} />
        <Route path="/make-payment" element={<MakePaymentScreen />} />
        <Route path="/profile" element={<ProfileScreen />} />
        <Route path="/change-plan" element={<ChangePlanScreen />} />
        {/* Removed onboarding page */}
      </Routes>
    </Router>
  );
}

export default App;
